import { LanguageLocale, LanguageMessagesKeys } from '../types/LanguageLocale'
import appLocalData from 'react-intl/locale-data/it'

const messages: LanguageMessagesKeys = { 


  // Common
  'side-effect.successful-title': 'Tutto bene!',
  'side-effect.successful-message': 'I dati sono stati salvati correttamente',
  'side-effect.internal-error-title': 'Qualcosa è andato storto',
  'side-effect.internal-error-message': 'Per favore, riprova più tardi o controlla la tua connessione internet',

  'monday-sshort-label': 'Mo',
  'tuesday-sshort-label': 'Tu',
  'wednesday-sshort-label': 'We',
  'thursday-sshort-label': 'Th',
  'friday-sshort-label': 'Fr',
  'saturday-sshort-label': 'Sa',
  'sunday-sshort-label': 'Su',

  'monday-short-label': 'Mon',
  'tuesday-short-label': 'Martedì',
  'wednesday-short-label': 'Mercoledì',
  'thursday-short-label': 'Giovedì',
  'friday-short-label': 'Venerdì',
  'saturday-short-label': 'Sat.',
  'sunday-short-label': 'Sole',

  'monday-label': 'Lunedì',
  'tuesday-label': 'Martedì',
  'wednesday-label': 'Mercoledì',
  'thursday-label': 'Giovedì',
  'friday-label': 'Venerdì',
  'saturday-label': 'Sabato',
  'sunday-label': 'Domenica',

  'january-label': 'Gennaio',
  'february-label': 'Febbraio',
  'march-label': 'Marzo',
  'april-label': 'Aprile',
  'may-label': 'May',
  'june-label': 'Giugno',
  'july-label': 'Luglio',
  'august-label': 'Agosto',
  'september-label': 'Settembre',
  'october-label': 'Ottobre',
  'november-label': 'Novembre',
  'december-label': 'Dicembre',

  'interval-name-year': 'anno',
  'interval-name-month': 'Mese',
  'interval-name-week': 'settimana',
  'interval-name-day': 'giorno',
  'interval-name-years': 'anni',
  'interval-name-months': 'mesi',
  'interval-name-weeks': 'settimane',
  'interval-name-days': 'giorni',

  'select-input.no-options-label': 'Nessuna opzione',
  'filter-input.label': 'Filtro',

  'no-data.label': 'Nessun dato da visualizzare. Modificare i filtri o la data selezionata.',
  'no-data.label-mid': 'Nessun dato da visualizzare. Cambia la data selezionata.',
  'no-data.label-short': 'Nessun dato da visualizzare.',
  'empty-list-label': 'Lista vuota.',
  'overlay.empty-device-label': 'Non sono stati aggiunti ancora dispositivi a questo profilo.',
  'overlay.empty-profiles-label': 'Nessun profilo aggiunto ancora.',
  'overlay.empty-device.add-device-label': 'Aggiungi dispositivo',

  'confirmation-modal.cancel-button': 'Annullare',
  'confirmation-modal.confirm-button': 'Confermare',
  'confirmation-modal.button-yes': 'Sì',
  'confirmation-modal.button-no': 'No',

  // Date Picker
  'date-picker.select-date-label': 'Seleziona data',

  // Date Filter
  'date-filter.select-label': 'Seleziona intervallo',
  'date-filter.this-month': 'Questo mese',
  'date-filter.this.week': 'Questa settimana',
  'date-filter.this.day': '24 ore',
  'date-filter.this.custom': 'Seleziona giorno',
  'date-filter.from-label': 'da',
  'date-filter.to-label': 'a',

  // Time Picker
  'time-picker.unlimied-label': 'Illimitato',
  'time-picker.time-format': '{h}h {m}min = {h}h {m}min',
  'time-picker.time-format-min': '{m} minuti',
  'time-picker.time-format-hour': 'h',

  'time-picker.add-bonus-title': 'Add time bonus only for today',
  'time-picker.no-bonus' : 'No bonus',
  'time-picker.bonus': 'Bonus',
  'time-picker.add-bonus-button-set': 'Set bonus',
  'time-picker.add-bonus-button-cancel' : 'Cancel',


  // Profile image picker
  'profile-image-picker.date-range-label': 'Intervallo di date',
  'profile-image-picker.girl-label': 'Ragazza',
  'profile-image-picker.boy-label': 'Ragazzo',

  // Profile List
  'profile-list.remove-device-label': 'Rimuovere dispositivo',
  'profile-list.move-device-label': 'Sposta il dispositivo su un altro profilo',
  'profile-list.add-device-label': 'Aggiungi dispositivo',

  'profile-list.add-profile-label': 'Aggiungi profilo',
  'profile-list.edit-profile-label': 'Modifica profilo',
  'profile-list.add-devices-label': 'Aggiungi nuovo dispositivo',
  'profile-list.remove-profile-label': 'Rimuovi profilo',
  'profile-list.remove-profile-disabled-tooltip': 'Per eliminare il tuo profilo, devi prima rimuovere tutti i dispositivi collegati al profilo.',
  'profile-list.title': 'Elenco dei profili',

  // Profile Form
  'profile-form.full-name-label': 'Nome',
  'profile-form.month-of-birth-label': 'Mese di nascita',
  'profile-form.year-of-birth-label': 'Anno di nascita',

  // Profile Form
  'profile-form-modal.create.skip-button': 'Annullare',
  'profile-form-modal.create.submit-button': 'Aggiungi profilo',
  'profile-form-modal.create.title': 'Aggiungi profilo bambino',
  'profile-form-modal.edit.skip-button': 'Annullare',
  'profile-form-modal.edit.submit-button': 'Salva',
  'profile-form-modal.edit.title': 'Modifica profilo bambino',
  'profile-form-modal.max-profiles-error': 'Limite del profilo raggiunto',

  // Profile Move Device Form
  'profile-move-device-modal.title': 'Sposta il dispositivo su un altro profilo',
  'profile-move-device-modal.cancel-button': 'Annullare',
  'profile-move-device-modal.submit-button': 'Salva',
  'profile-move-device-modal.select-profile-label': 'Scegli profilo',

  // CallLog
  'call-log.duration-label': 'Durata della chiamata',
  'call-log.seconds-label': 's.',

  // Create Profile Page
  'create-profile-page.submit-button': 'Aggiungi profilo',
  'create-profile-page.skip-button': 'Annullare',
  'create-profile-page.title': 'Aggiungi profilo bambino',
  'create-profile-page.description': 'Chi sarà monitorato',

  // Add device page
  'add-device-page.close-button': 'Chiudere',
  'add-device-page.description': "Scegli il tipo di dispositivo per installare l'app.",
  'add-device-page.title': "Guida all'installazione",
  'add-device-page.check': 'Controllare il manuale',
  'add-device-page.mobile-title': 'Telefono o tablet Android',
  'add-device-page.mobile-description': 'Versione Android 6 o superiore',
  'add-device-page.desktop-title': 'Desktop o laptop Windows',
  'add-device-page.desktop-description': 'Versione di Windows 7 o superiore',


  // Purchase Page
  'purchase-page.skip-label': 'Vai al cruscotto',
  'purchase-page.title': 'Scegli il miglior piano.',
  'purchase-page.title.features': 'Tutti i piani offrono le seguenti funzioni',
  'purchase-page.title.reviews': 'Perché i nostri utenti ci amano',
  'purchase-page.subtitle': 'Se il programma non soddisfa le tue aspettative, ti rimborsiamo il pagamento.',
  'purchase-page.plan-highlight': 'Miglior valore',
  'purchase-page.monthly': 'mensile',
  'purchase-page.select': 'Scegli',
  'purchase-page.close': 'Chiudi',
  'purchase-page.money-back.title': 'Rischio libero',
  'purchase-page.money-back.desc': 'Se non sei soddisfatto, sarai rimborsato.',
  'purchase-page.header.check-1': 'Migliore app di controllo parentale',
  'purchase-page.header.check-2': 'Imposta un limite di tempo per i giochi, YouTube e siti web.',
  'purchase-page.header.check-3': 'Centinaia di migliaia di clienti soddisfatti',
  'purchase-page.plan.year': 'anno',
  'purchase-page.plan.optimal': 'Miglior valore',


  'purchase-page.modal.2y-header': 'Offerta speciale!',
  'purchase-page.modal.2y-sub-header': 'Scegli il piano biennale e risparmia <s>{baseAmount} {currency}</s> <span class="discounted-price">{amount} {currency}</span>',
  'purchase-page.modal.2y-sub-header2': 'Scegli il piano biennale e risparmia <s>{baseAmountCurrency}</s> <span class="discounted-price">{amountCurrency}</span>',
  'purchase-page.modal.protect-plan-devices': 'Proteggere fino a {dispositivi} dispositivi',
  'purchase-page.modal.upgrade': 'Scegli lo sconto',
  'purchase-page.modal.no-thanks': 'Continua con il piano di 1 anno',


  'purchase-plan.features.title.feature_1': 'Limite di tempo per app e giochi',
  'purchase-plan.features.title.feature_2': 'Filtro del sito web',
  'purchase-plan.features.title.feature_3': 'Bloccare app, giochi e siti web',
  'purchase-plan.features.title.feature_4': 'Monitoraggio di Youtube',
  'purchase-plan.features.title.feature_5': 'Visualizzazione remota dello schermo in diretta',
  'purchase-plan.features.title.feature_6': 'Accesso remoto',
  'purchase-plan.features.title.feature_7': 'Rapporti dettagliati',
  'purchase-plan.features.title.feature_8': 'Posizione (solo telefono)',
  'purchase-plan.features.title.feature_9': 'Controllare messaggi e chiamate',
  'purchase-plan.features.title.feature_10': 'Supporto tecnico prioritario',

  'purchase-plan.features.desc.feature_1': "Imposta limiti di tempo per le app, i giochi e l'accesso a Internet. Inoltre, pianifica in quale orario il tuo bambino può accedervi.",
  'purchase-plan.features.desc.feature_2': "Tutti i siti web inappropriati sono bloccati. Il programma utilizza un algoritmo che analizza i contenuti del sito web per qualsiasi materiale non adatto. Inoltre, raccoglie informazioni da un'enorme collezione di database di siti web e parole inappropriati, entrambi i quali vengono regolarmente aggiornati.",
  'purchase-plan.features.desc.feature_3': 'Blocca le app e i siti web che potrebbero avere un impatto negativo sui tuoi figli. Inoltre, qualsiasi nuovo gioco installato richiederà la tua autorizzazione.',
  'purchase-plan.features.desc.feature_4': "Nella dashboard, monitorare tutti i video che il tuo bambino guarda su YouTube. Bloccare qualsiasi video o bloccare completamente l'accesso ai servizi video.",
  'purchase-plan.features.desc.feature_5': 'Accedere da remoto a un flusso live dello schermo del tuo bambino e controllare la loro attività durante tutto il giorno. Ciò consente di tenere un occhio attento sul contenuto che il tuo bambino sta accedendo.',
  'purchase-plan.features.desc.feature_6': "Una volta effettuato l'accesso, è possibile accedere al cruscotto dei genitori da qualsiasi luogo e da qualsiasi dispositivo. Nel cruscotto, regolare le impostazioni, monitorare i dispositivi dei bambini e impostare limiti di tempo.",
  'purchase-plan.features.desc.feature_7': "Nel pannello dei genitori, monitorare facilmente l'attività di un bambino sul loro computer o telefono, vedere quanto tempo hanno trascorso davanti allo schermo, quali siti web hanno visitato e molto altro.",
  'purchase-plan.features.desc.feature_8': 'Controlla la posizione attuale e le posizioni passate del tuo bambino sulla mappa. Vedi esattamente dove si trovava il tuo bambino in un determinato giorno o in un determinato momento.',
  'purchase-plan.features.desc.feature_9': 'Puoi facilmente controllare i messaggi inviati e ricevuti, le chiamate e i contatti salvati del tuo bambino utilizzando il pannello dei genitori.',
  'purchase-plan.features.desc.feature_10': 'Se hai bisogno di aiuto, siamo sempre disponibili. Ci sono anche molti video guide per aiutarti a usare {app}.',



  'purchase-plan.raitings.desc.name_1': 'Sofia',
  'purchase-plan.raitings.desc.name_2': 'Olivia',
  'purchase-plan.raitings.desc.name_3': 'Mateo',
  'purchase-plan.raitings.desc.name_4': 'Lucas',
  'purchase-plan.raitings.desc.name_5': 'Emma',
  'purchase-plan.raitings.desc.name_6': 'Emma',

  'purchase-plan.raitings.desc.raiting_1': 'Molto efficiente! Protegge completamente il mio bambino dai contenuti internet nocivi.',
  'purchase-plan.raitings.desc.raiting_2': "Esattamente quello che stavo cercando! Ho impostato un limite giornaliero di un'ora per le mie figlie che accedono a Internet e Avosmart se ne occupa per me.",
  'purchase-plan.raitings.desc.raiting_3': 'Io consiglio Avosmart perché ha una varietà di funzioni. I miei figli sono protetti quando usano internet e io sono in grado di controllare quanto tempo trascorrono giocando ai giochi, ecc.',
  'purchase-plan.raitings.desc.raiting_4': "Era importante per mia moglie ed io poter tenere d'occhio le abitudini sui social media della nostra figlia. Avosmart ci aiuta a mantenere un equilibrio tra la vita digitale e quella reale della nostra figlia.",
  'purchase-plan.raitings.desc.raiting_5': 'Mio figlio usava trascorrere troppo tempo su internet, usando un laptop, un tablet, ecc. Con i report forniti da Avosmart, so esattamente quali siti web visita mio figlio e per quanto tempo.',
  'purchase-plan.raitings.desc.raiting_6': 'Ora sono in grado di controllare la posizione attuale di mio figlio in qualsiasi momento. Un eccellente servizio!',


  'account-settings-page.title': 'Impostazioni account',
  'account-settings-page.automatic-update': 'Aggiornamenti automatici delle applicazioni di Windows',
  'account-settings-page.timezone': 'Fuso orario',
  'account-settings-page.send-reports': "Invia rapporti sull'attività giornaliera",


  'plans-info-page.title': "Informazioni sull'abbonamento",
  'plans-info-page.plan': 'Piano',
  'plans-info-page.max-devices': 'Numero massimo di dispositivi:',
  'plans-info-page.valid-till': 'Data di scadenza',

  'plans-info-page.your-plan': 'Il tuo piano:',
  'plans-info-page.subscription-information': "Informazioni sull'abbonamento",
  'plans-info-page.subscription-created': 'Iscrizione creata:',
  'plans-info-page.subscription-current-period': 'Periodo di abbonamento corrente:',
  'plans-info-page.subscription-renews-on': 'Il tuo piano si rinnova il',
  'plans-info-page.subscription-cancel-renewal': 'Annullare rinnovo',
  'plans-info-page.subscription-not-renewed': 'Il tuo piano NON sarà rinnovato alla fine del periodo corrente.',
  'plans-info-page.subscription-enable-renewal': 'Abilita rinnovo',
  'plans-info-page.subscription-price': "Prezzo dell'abbonamento",
  'plans-info-page.subscription-price-amount': '{amount} ogni {periodo}',


  'plans-info-page.upgrade-plan': 'Aggiorna il tuo piano',
  'plans-info-page.extend-lic': 'Estendere il tuo piano',
  'plans-info-page.subscriptions-portal': 'Gestisci i tuoi metodi di pagamento',
  'plans-info-page.recent-payments': 'Ultime transazioni',
  'plans-info-page.date-of-payment': 'Data della transazione',
  'plans-info-page.transaction-status': 'Completato',
  'plans-info-page.no-recent-payments': 'Nessuna transazione recente',
  'plans-info-page.btn-close': 'Chiudi',
  'plans-info-page.plan-devices': 'fino a {dispositivi} dispositivi',
  'plans-info-page.plan-devices-types': 'computer	ablet	elefoni',


  'upgrade-page.title': 'Aggiornare il piano',
  'upgrade-page.devices': 'Dispositivi',
  'upgrade-page.valid-till': 'Il tuo piano è valido fino a:',
  'upgrade-page.confirm-upgrade': 'Il tuo piano verrà aggiornato, ti verrà addebitato {importo}',
  'upgrade-page.pay-now': 'Paga ora {importo}',
  'upgrade-page.pay-then': 'Allora {importo} ogni {periodo}',


  // Purchase Checkout (Stripe ver)

  'purchase-checkout.buy-subscription': 'Comprare abbonamento',
  'purchase-checkout.up-to-devices': 'Fino a {dispositivi} dispositivi',
  'purchase-checkout.subscribtion-price': '{amount} ogni {periodo}',
  'purchase-checkout.subscribe': 'Iscriviti',
  'purchase-checkout.cancel': 'Annullare',


  // Purchase Status Page
  'purchase-status-page.title': 'Controllo del pagamento',
  'purchase-status-page.status-pending': 'In sospeso',
  'purchase-status-page.status-completed': 'Completato',
  'purchase-status-page.status-canceled': 'Cancellato',
  'purchase-status-page.status-refund-finalized': 'Rimborso finalizzato',
  'purchase-status-page.status-wating-for-conf': 'In attesa di conferma',
  'purchase-status-page.status-created': 'Creato',
  'purchase-status-page.status-unkown': 'Sconosciuto',
  'purchase-status-page.status-error': 'Errore',
  'purchase-status-pag.back-button': 'Torna alla pagina principale',
  'purchase-status-pag.invoice-link': 'Vorrei ricevere una fattura IVA',

  // Login Page
  'login-page.brandline': 'Accedi',
  'login-page.brandline2': 'Filtro del sito web',
  'login-page.email-label': 'Indirizzo e-mail',
  'login-page.login-button': 'Accedi',
  'login-page.password-label': 'Password: Password',
  'login-page.recovery-link': 'Dimenticare la password?',
  'login-page.invalid-login-error': "L'indirizzo email o la password inseriti non sono validi.",

  // Register Page
  'register-page.create-account-label': 'Hai bisogno di un account? Crea un nuovo account',
  'register-page.description': 'Crea il tuo account gratuito',
  'register-page.email-label': 'Indirizzo e-mail',
  'register-page.login-link-label': 'Hai un account? Accedi',
  'register-page.marketing-checkbox-label': 'Accetto di ricevere materiali di marketing e promozionali',
  'register-page.password-label': 'Password: Password',
  'register-page.phoneNumber-label': 'Numero di telefono',
  'register-page.terms-privacy-checkbox-label': 'Accetto la politica sulla privacy e i termini di utilizzo',
  'register-page.register-button': 'Registrarsi',
  'register-page.register-success-title': 'Successo',
  'register-page.register-success-message': "Registrazione riuscita. Controlla la tua casella di posta per confermare l'email",
  'register-page.register-error-captcha': 'Errore Captcha. Riprova.',
  'register-page.register-error-already-registered-label': 'Già registrato. Prova a effettuare il login o ricorda la password.',
  'register-page.register-error-password-to-short-label': 'Password troppo corta.',

  // Forgot Password Page
  'register-page.strong-pass': 'La tua password è troppo semplice e potrebbe essere facilmente decifrata da altre persone. La tua password dovrebbe contenere lettere maiuscole e minuscole e numeri, e dovrebbe essere almeno 8 caratteri di lunghezza. Sei sicuro di voler usare una password semplice?',
  'forgot-password-page.headline-title': 'Ricorda la password',
  'forgot-password-page.email-label': 'Indirizzo e-mail',
  'forgot-password-page.reset-button': 'Ricorda la password',
  'forgot-password-page.login-link-label': 'Torna alla pagina di accesso',
  'forgot-password-page.success-title': 'Reimpostazione della password',
  'forgot-password-page.success-message': 'Controlla la tua casella di posta per le istruzioni su come reimpostare la tua password.',
  'forgot-password-page.email-not-confirmed': 'Il tuo indirizzo email non è verificato. Il ripristino della password non è disponibile.',

  // Update Password Page
  'update-password-page.headline-title': 'Impostare una nuova password',
  'update-password-page.warning-title': 'NOTA',
  'update-password-page.warning-description': 'Impostare una nuova password comporterà la perdita dei dati di posizione salvati in precedenza. I dati rimanenti non andranno persi.',
  'update-password-page.warning-agreement': 'Capisco e accetto la perdita di dati di posizione.',
  'update-password-page.new-password': 'Nuova password:',
  'update-password-page.new-password-retype': 'Ripeti la nuova password',
  'update-password-page.submit': 'Imposta una nuova password',
  'update-password-page.alert-weak-password': 'La tua password è troppo semplice e potrebbe essere facilmente indovinata da persone non autorizzate. La password dovrebbe contenere lettere maiuscole, lettere minuscole, numeri e avere almeno 8 caratteri. Vuoi comunque usare una password semplice?',
  'update-password-page.alert-agreement': 'Accettazione della perdita di dati è richiesta.',
  'update-password-page.error-message': 'Errore! Impostare una nuova password non è riuscita.',
  'update-password-page.success-message': 'Nuova password impostata',
  'update-password-page.unknow-error-message': 'Qualcosa è andato storto',
  'update-password-page.error-link': 'Collegamento sbagliato',
  'update-password-page.error-posswords-not-equal': 'Password non uguali',
  'update-password-page.error-posswords-length': 'Password troppo corte',
  'update-password-page.error-wrong-code': 'Codice sbagliato',
  'update-password-page.register-success-title': 'Successo!',
  'update-password-page.register-success-message': 'Nuova password impostata.',

  // Error Page
  'not-found-page.title': 'Oops... sembra che si sia verificato un errore!',
  'not-found-page.error-code-text': 'Codice di errore',
  'not-found-page.go-back-home-button': 'Vai a casa',

  // Panel Page
  'panel-page.purchase-ending-soon-alert': "Il tuo piano termina il {data}. Ti preghiamo di considerare l'acquisto di un abbonamento oggi.",
  'panel-page.purchase-demo-alert': 'Stai attualmente usando la versione di prova.',
  'panel-page.purchase-expired-alert': 'Stai attualmente utilizzando una versione di prova scaduta. Acquista abbonamenti per continuare a utilizzare il software.',
  'panel-page.purchase-lic-expired-alert': 'Il tuo piano di abbonamento è scaduto. Acquista abbonamenti per continuare',
  'panel-page.email-alert': 'Non hai confermato il tuo indirizzo email',
  'panel-page.button-email-resend': 'Rinviare la email',
  'panel-page.email-alert-resend': 'Invia di nuovo la email.',
  'panel-page.email-alert-resend-title': 'Conferma',
  'panel-page.email-alert-resend-msg': 'Email è stata inviata!',
  'panel-page.profile-delete-description': 'Sei sicuro di voler eliminare il profilo selezionato?',
  'panel-page.profile-delete-device-description': 'Sei sicuro di voler eliminare il dispositivo selezionato? I dati andranno persi.',
  'panel-page.profile-delete-device-second-description': 'La protezione sul dispositivo verrà disabilitata. Sei sicuro di voler continuare?',

  'panel-page.email-confirmation-overlay-close': 'Chiudi',
  'panel-page.email-confirmation-overlay-postpone': 'Più tardi',
  'panel-page.email-confirmation-overlay-resend': 'Rinviare la email',
  'panel-page.email-confirmation-overlay-header': 'Il tuo indirizzo e-mail qui sotto non è stato confermato.',
  'panel-page.email-confirmation-overlay-desc': "Se hai fatto un errore con l'indirizzo e-mail sopra, ti preghiamo di farcelo sapere immediatamente. Se non hai ricevuto l'email, fai clic su \"invia di nuovo\" e controlla le altre cartelle della tua email (inclusa la cartella spam).",

  'panel-page.email-confirmation-code-success-header': 'Grazie',
  'panel-page.email-confirmation-code-success-desc': 'Email confermata!',
  'panel-page.email-confirmation-code-header': 'Inserisci il codice di conferma a 6 cifre inviato al tuo indirizzo email.',
  'panel-page.email-confirmation-code-error-invalid-code': 'Il codice dato non è valido.',
  'panel-page.email-confirmation-code-error': 'Si è verificato un errore imprevisto durante la convalida del codice',

  // Summary Page
  'summary-page.title': 'Cruscotto',
  'summary-page.top-apps.title': 'Le migliori app',
  'summary-page.top-blocked.title': 'Bloccato in alto',
  'summary-page.top-domains.title': 'Pagine web più visitate',
  'summary-page.top-search.title': 'Ricerca principale',
  'summary-page.access-disable': 'Disattivazione temporanea',
  'internet-page.access-time-limit-set-label': "Limite giornaliero per l'accesso a Internet",
  'internet-page.access-time-limit-description': 'Imposta limiti di tempo giornalieri per ogni dispositivo e scegli quante ore di utilizzo di Internet sono consentite.',
  'disable-access.protection-enabled': 'Protezione è attiva',
  'disable-access.protection-disabled-for': 'La protezione è temporaneamente disabilitata, {tempo} minuti rimasti.',
  'disable-access.device-offline': 'Dispositivo non disponibile',
  'disable-access.protection-status': 'Stato di protezione',


  // Internet Page
  'internet-page.headline-title': 'Pagine web',
  'internet-page.access-time-page-title': 'Tempo di accesso',
  'internet-page.settings-page-title': 'Impostazioni',
  'internet-page.statistics-page-title': 'Statistiche',
  'internet-page.searches-page-title': 'Ricerche',

  'internet-page.statistics-page-www-ok': 'Sito web approvato',
  'internet-page.statistics-page-www-ok-white': 'Sito web sicuro',
  'internet-page.statistics-page-www-timelimit': 'Sito bloccato a causa dei limiti di tempo',
  'internet-page.statistics-page-www-userdef': 'Sito bloccato, definizioni utente',
  'internet-page.statistics-page-www-content': 'Sito bloccato, contenuto inappropriato',


  'internet-page.white-black-list-page-title': 'Siti web sicuri / bloccati',
  // Internet Page / Settings page
  'internet-page.settings-page.filters.card-title': 'Filtri',
  'internet-page.settings-page.white-list-only-label': "Solo consentire l'accesso ai siti nella lista sicura",
  'internet-page.settings-page.block-erotic-label': "Bloccare l'accesso ai siti web erotici",
  'internet-page.settings-page.block-offensive-label': "Bloccare l'accesso a siti offensivi e aggressivi",
  'internet-page.settings-page.block-file-sites-label': "Bloccare l'accesso alle pagine che consentono il download di file da Internet",
  'internet-page.settings-page.block-video-label': "Bloccare l'accesso ai portali video",
  'internet-page.settings-page.block-social-label': "Bloccare l'accesso ai social network",
  'internet-page.settings-page.block-doc-label': 'Bloccare i documenti dal essere scaricati',
  'internet-page.settings-page.block-exe-label': 'Bloccare i programmi dal essere scaricati',
  'internet-page.settings-page.excludeYT-label': 'Non forzare la ricerca sicura su YouTube',
  'internet-page.settings-page.block-new-apps': 'Bloccare nuove applicazioni',
  'internet-page.settings-page.block-settings': "Bloccare l'accesso alle impostazioni",
  'internet-page.settings-page.custom-msg.card-tile': 'Messaggio per pagine bloccate',
  'internet-page.settings-page.custom-msg.custom-msg-on-label': 'Usa un messaggio personalizzato per i siti web bloccati',
  'internet-page.settings-page.save-settings-button-label': 'Salva impostazioni',
  // Internet Page / Lists / White list
  'internet-page.lists.add-to-list-label': 'Aggiungi alla lista',
  'internet-page.lists.add-button-label': 'Aggiungere',
  'internet-page.lists.remove-button-label': 'Cancellare',
  'internet-page.lists.white-list.card-title': 'Lista sicura',
  'internet-page.lists.black-list.card-title': 'Lista bloccata',
  'internet-page.lists.remove-prefix': "L'indirizzo inserito inizia con \"{prefix}\", si consiglia di aggiungere solo il nome di dominio. Vuoi rimuovere \"{prefix}\" dall'indirizzo?",

  // Internet Page /  Statistics
  'internet-page.statistics.visited-pages-card-title': 'Pagine visitate',

  'internet-page.searches.searches-pages-card-title': 'Frasi cercate',

  // Internet Page / Access Time
  'internet-page.access-time.schedule-card-title': 'Programma',
  'internet-page.access-time.schedule-legend-label': "Legenda dell'orario",
  'internet-page.access-time.schedule-internet-available-label': 'Internet disponibile',
  'internet-page.access-time.schedule-internet-blocked-label': 'Internet bloccato',

  // Calls And SMS Page
  'calls-text-messages-page.headline-title': 'Chiamate e messaggi di testo (SMS)',

  // Calls and SMS Page / Calls List
  'calls-text-messages-page.calls-list-title': 'Chiamate',
  // Calls And SMS Page / List
  'calls-text-messages-page.sms-list-title': 'Messaggi di testo (SMS)',
  // Calls And SMS Page / Contacts
  'calls-text-messages-page.contacts-last-changed-label': 'Ultimo cambiamento',
  'calls-text-messages-page.contacts-no-changes-label': 'Vuoto.',
  'calls-text-messages-page.contacts-phone-label': 'tel.',
  'calls-text-messages-page.contacts-title': 'Contatti',

  // Localization Page
  'localization-page.headline-title': 'Posizione',
  'localization-page.headline-title-off': 'Localizzazioni, il tracciamento GPS è spento',
  'localization-page.map-hours-filter-label': 'Seleziona un intervallo di tempo per visualizzare la cronologia della posizione',
  'localization-page.gps-tracking-on': 'Tracciamento GPS abilitato',
  'localization-page.gps-view-speed': 'Mostra velocità di viaggio',
  'localization-page.map-loading-label': 'Caricamento mappe...',
  'localization-page.map-no-data': 'Nessun dato',

  'localization-page.one-gps-was-off-since': 'Servizi di localizzazione del dispositivo disattivati dal {lastOffStr}',
  'localization-page.one-gps-was-off-for': 'Servizi di localizzazione del dispositivo disattivati per {elapsedStr}',
  'localization-page.many-gps-was-off-since': 'Servizi di localizzazione del dispositivo disattivati dal {lastOffStr}',
  'localization-page.many-gps-was-off-for': 'Servizi di localizzazione del dispositivo disattivati per {elapsedStr}',


  // Battery Page
  'battery-page.headline-title': 'Batteria',
  'battery-page.chart-description': 'Livello della batteria',

  // Access Time Page
  'access-time-page.headline-title': 'Tempo di accesso',
  'access-time-page.nav-access-time-label-applications': 'Applicazioni',
  'access-time-page.nav-access-time-label-internet': 'Pagine web',

  // YouTube Page
  'youtube-page.headline-title': 'YouTube',
  'youtube-page.chart-description': 'YouTube',
  'youtube-page.videos-list': 'Lista dei video',
  'youtube-page.no-videos': 'Nessun video sulla data selezionata',
  'youtube-page.block-videoid': 'Blocca questo video',
  'youtube-page.block-channelid': 'Blocca questo canale',
  'youtube-page.video-blocked': 'Bloccato',

  // Screen Pages
  'screenview-page.headline-title': 'Visualizzazione dello schermo',
  'screenview-page.reload-button': 'Ricarica',
  'screenview-page.chart-description': 'Vista dello schermo corrente',
  'screengrab-page.headline-title': 'Cattura schermo',
  'screengrab-page.chart-description': 'Cattura schermo',
  'screengrab-page.screen-save-time': 'Quanto spesso viene effettuato uno screenshot?',
  'screengrab-page.screen-save-time-desc': 'Scegli quanto spesso viene effettuato il grab dello schermo o scegli "disabilitato" per non effettuare alcun grab dello schermo.',
  'screengrab-page.screen-save-time-disabled': 'disabilitato',
  'screengrab-page.no-screens-for-today': 'Nessun screenshot preso in questo giorno',
  'screengrab-page.no-screens-for-filter': 'Nessun schermo corrispondente ai criteri selezionati',
  'screengrab-page.imgs-delete-description': 'Sei sicuro di voler eliminare le immagini selezionate?',
  'screengrab-page.imgs-delete-description-one': "Sei sicuro di voler eliminare l'immagine selezionata?",
  'screengrab-page.imgs-delete-label': 'Cancellare',
  'screengrab-page.imgs-delete-select': 'Seleziona per eliminare',
  'screengrab-page.imgs-delete-selected': 'Selezionato',
  'screengrab-page.imgs-delete-limit': 'Il limite di screenshot selezionato è stato raggiunto.',
  'screengrab-page.imgs-filter': 'Filtro',
  'screengrab-page.imgs-filter-communicators': 'Comunicatori',
  'screengrab-page.imgs-filter-social': 'Media Sociali',
  'screengrab-page.imgs-filter-video': 'Video',
  'screengrab-page.imgs-filter-others': 'Altri',

  'screes-pages.device-offline': 'Dispositivo è offline',
  'screes-pages.device-deactivated': 'La protezione è stata temporaneamente disattivata.',
  'screes-pages.device-timeout': 'Dispositivo non ha risposto',
  'screes-pages.device-screenoff': 'Lo schermo è spento',
  'screes-pages.device-notallowed': 'Cattura dello schermo non consentita sul dispositivo',
  'screes-pages.device-error': 'Si è verificato un errore.',

  'lazy-image.img-delete-description': "Sei sicuro di voler eliminare l'immagine selezionata?",

  // Applications Page
  'applications-page.headline-title': 'Applicazioni',
  'applications-page.nav-access-time-label': 'Tempo di accesso',
  'applications-page.nav-statistics-label': 'Riassunto',
  'applications-page.nav-apps-list-label': 'Lista di app',
  'applications-page.chart-activity-by-day-label': 'Attività durante il giorno',
  'applications-page.chart-hour-label': 'Ora',
  'applications-page.chart-activity-by-hour-minutes-label': 'Attività durante il giorno in minuti',
  'applications-page.list-launched-count-label': 'Numero di lanci:',
  'applications-page.list-elapsed-time-label': 'Tempo di esecuzione',
  'applications-page.introduction': 'App installate',

  // Applications Page / Settings
  'applications-page.settings.headline-title': 'Intervallo di tempo programmato',
  'applications-page.settings.schedule-legend-label': "Legenda dell'orario",
  'applications-page.settings.schedule-blocked-label': 'App bloccate',
  'applications-page.settings.schedule-available-label': 'App disponibili',
  'applications-page.time-limit.description': "Imposta un limite di tempo per le app specifiche. Scegli quante ore al giorno è consentito l'utilizzo dell'applicazione.",
  'applications-page.apps-headline-title': 'App disponibili',
  'applications-page.apps-first-seen-label': 'Prima vista',
  'applications-page.apps-available-switch-label': 'Disponibile',
  'applications-page.apps-not-available-switch-label': 'Non disponibile',
  'applications-page.apps-schedule-switch-label': 'Programmato',
  'applications-page.apps-no-schedule-switch-label': 'Non programmato',
  'applications-page.apps-time-limit-switch-label': 'Limite di tempo',
  'applications-page.apps-no-time-limit-switch-label': 'Nessun limite di tempo',
  'applications-page.apps-show-uninstalled-label': 'Mostra applicazioni non installate',
  'applications-page.apps-show-apps-list': 'App a tempo limitato',

  'applications-page.used-count-zero-label': 'Non lanciato',
  'applications-page.used-count-one-label': 'Lanciato {valore} volte, tempo totale: {tempoTotale}',
  'applications-page.used-count-many-label': 'Lanciato {valore} volte, tempo totale: {tempoTotale}',
  'applications-page.total-hours-minutes-label': '{ore} h {minuti} min',
  'applications-page.total-minutes-seconds-label': '{minuti} min {secondi} sec',
  'applications-page.total-minutes-label': '{minutes} minuti',
  'applications-page.total-seconds-label': '{seconds} sec',
  'applications-page.total-time-label': 'Tempo totale',

  // EmailConfirmationPage
  'email-confirmation-page.bad-code-label': 'Il link di attivazione è stato utilizzato o non è valido.',
  'email-confirmation-page.successful-confirm': 'Email confermata. Grazie!',
  'email-confirmation-page.button-home-page-label': 'OK = OK',

  // Change password
  'change-password-page.change-password-label': 'Cambia password',
  'change-password-page.new-password-input-label': 'Nuova password',
  'change-password-page.new-password-repeated-input-label': 'Ripeti la nuova password',
  'change-password-page.current-password-input-label': 'Password attuale',
  'change-password-page.back-button-label': 'Indietro',
  'change-password-page.change-button-label': 'Cambiare',
  'change-password-page.successful-change-label': 'La password è stata cambiata correttamente',
  'change-password-page.wrong-current-password-label': 'Password corrente errata',
  'change-password-page.password-too-short-label': 'La nuova password è troppo corta.',

  // TopNavigation
  'top-navigation.hamburger-menu': 'Menu',
  'top-navigation.user-menu.account-label': 'Account',
  'top-navigation.user-menu.sign-out': 'Esci',
  'top-navigation.user-menu.subscription-label': 'Piano di sottoscrizione',
  'top-navigation.user-menu.change-password-label': 'Cambia password',
  'top-navigation.user-menu.add-device-label': 'Aggiungi dispositivo',

  // Sidebar
  'sidebar.menu-item.applications': 'Applicazioni',
  'sidebar.menu-item.calls-and-text-messages': 'Chiamate e Testi (SMS)',
  'sidebar.menu-item.internet': 'Pagine Web',
  'sidebar.menu-item.localizations': 'Localizzazioni',
  'sidebar.menu-item.social-networks': 'Reti sociali',
  'sidebar.menu-item.summary': 'Cruscotto',
  'sidebar.menu-item.battery': 'Batteria',
  'sidebar.menu-item.youtube': 'YouTube',
  'sidebar.menu-item.screenview': 'Visualizzazione dello schermo',
  'sidebar.menu-item.screengrab': 'Cattura schermo',
  'sidebar.menu-item.access-time': 'Tempo di accesso',

  // Validator
  'phone-number.not-valid': 'Inserisci un numero di telefono valido',
  'input.required-label': 'Campo è richiesto',
  'input.select-required-label': 'Si prega di selezionare',
  'email.not-valid-label': 'Inserisci un indirizzo e-mail valido',
  'domain-exist-label': 'Dominio è stato aggiunto',
  'domain-exist-other-label': 'Esiste un dominio su altre liste',
  'domain-not-valid': 'Dominio non valido',
  'password-not-match-label': 'Password non corrispondente',

  // misc
  'button-buy-label': 'Scegli un piano',

  'transactiion-status-0': 'In attesa',
  'transactiion-status-1': 'Completato',
  'transactiion-status--1': 'Cancellato',
  'transactiion-status--2': 'Cancellato - rimborso',
  'transactiion-status--3': 'In attesa di conferma',
  'transactiion-status--100': 'Iniziato',
  'transactiion-status-other': 'Altro',

  // reward

  'reward-page.error-ok': 'OK = OK',
  'reward-page.error-success': 'Successo',
  'reward-page.error-already-used': 'Questo codice è già stato usato',
  'reward-page.error-invalid-code': 'Codice errato',
  'reward-page.error-connection': 'Errore di connessione',
  'reward-page.additional-bonus': 'Bonus',
  'reward-page.get-additional-bonus': 'Rivendica coupon promozionale',
  'reward-page.get-now': 'Reclamo',
  'reward-page.lic-was-extended-by-days': 'Il tuo piano di abbonamento è stato esteso di {rewardDays} giorni!',
  'reward-page.there-was-an-error': 'Purtroppo si è verificato un errore.',
  'reward-page.lic-not-extended': 'Il tuo piano di abbonamento non è stato esteso.',
  'reward-page.button-close': 'Chiudi',

  // url item
  'url-item.copied': 'Copiato negli appunti',
  'url-item.copy-link': 'Copia il link',

  // APK howto

  'apk-howto-google-play': "Google Play Store limita determinate autorizzazioni dell'applicazione che sono necessarie per utilizzare questa funzione.",
  'apk-howto-on-the-phone': 'Su un telefono per bambini con {applite} installato',
  'apk-howto-step1': 'Disinstallare {applite} se precedentemente scaricato tramite Google Play.',
  'apk-howto-step2': "Scarica l'app direttamente sul telefono del bambino attraverso il nostro sito web.",
  'apk-howto-step2B': 'Scansiona il codice QR sotto sul telefono del bambino.',
  'apk-howto-step3': "Installare l'app scaricata sul dispositivo.",
  'apk-howto-tutorial': "Guida su come installare l'app su un telefono o un tablet",

  // Cookies

  'cookies-info-uses': 'Questo sito web utilizza i cookie.',
  'cookies-info-privacy-policy': 'Più nella politica sulla privacy.',

  // Plan names

  'plan-name-demoExpired': 'Scadenza del periodo di prova',
  'plan-name-licExpired': 'Piano scaduto',
  'plan-name-reward': 'Bonus',
  'plan-name-demo': 'Prova',
  'plan-name-minimal': 'Base',
  'plan-name-regular': 'Regolare',
  'plan-name-premium': 'Premium',

  // agreements

  'agreement-will-inform-user': "Dichiaro che informerò l'utente su cui dispositivo verrà installata l'app che la loro attività e posizione saranno monitorate.",

  'agreement-privacy-policy': 'Dichiaro di aver letto e accettato i <a href="{regulations}" target="_blank">termini</a> e la <a href="{privacy}" target="_blank">politica sulla privacy</a>. Certifico di avere più di 18 anni e di aggiungere al mio account solo bambini di età inferiore ai 18 anni che sono i miei dipendenti legali.',

  // 'agreement-marketing' : 'I consent to being delivered marketing information by {domain} regarding promotional offers to the e-mail address and phone number provided by me during the registration process. <a href="{marketing}" target="_blank">More</a>'
  'agreement-marketing': "Acconsento a ricevere contenuti di marketing da {domain} riguardanti offerte promozionali all'indirizzo email e al numero di telefono forniti, nonché a inoltrare i dettagli ai partner pubblicitari del sito menzionati nella politica sulla privacy allo scopo di pubblicità digitale. <a href=\"{marketing}\" target=\"_blank\">Ulteriori informazioni</a>",

}

export default {
  locale: 'it-IT',
  name: 'Italiano',
  data: appLocalData,
  messages
} as LanguageLocale
